import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { StoryProvider } from "../../context/StoryContext";
import StoryEditorInner from "./StoryEditorInner";

const StoryEditor = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <StoryProvider initialStoryId={location.state}>
      <StoryEditorInner navigate={navigate} />
    </StoryProvider>
  );
};

export default StoryEditor;